<script>
import Head from '@/components/Head';
import Table from '@/components/Table';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Select from '@/components/Select';
import Loader from '@/components/Loader';
import SimpleModal from '@/components/SimpleModal';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    data() {
        return {
            loader: true,
            loadingTable: true,
            hasNextPage: false,
            itemsPerPage: 10,
            actualPage: 0,
            totalItems: 0,
            associateTableCategories: [
                'Meio do crédito',
                'Data do crédito',
                'Contribuição',
                'Taxa de adesão',
                'Honorários',
                'Encargos',
                'Total'
            ],
            totalSumPayments: 0,
            totalCreditValue: 0,
            totalCreditValueMonthly: 0,
            totalCreditValueSemiannual: 0,
            totalCreditValueAnnual: 0,
            totalMembershipFee: 0,
            totalCharges: 0,
            totalFees: 0,
            totalRefundTransfer: 0,
            totalBonusValue: 0,
            previousDebts: 0,
            financial_situation: '',
            financial_situation_description: '',
            payments: [],
            paymentsFullInfos: [],
            filtersData: {
                initial_date: '2019-11-28',
                finish_date: this.getCurrentDate(),
            },
            modalFinancialSpreadsheet: false,
            installments: [],
            loadingInstallments: false,
        }
    },
    props: {
        userData: {
            type: Object
        }
    },
    created() {
        if (this.userData.is_associate == 0) {
            this.$router.push('/inicio');
        }

        this.getNextPayment();
    },
    methods: {
        notify(text, type) {
            toast(text, {
                "type": type == 'info' ? 'info' : type == 'warning' ? 'warning' : type == 'error' ? 'error' : type == 'success' ? 'success' : 'default',
            });
        },
        getCurrentDate() {
            var data = new Date();

            var year = data.getFullYear();
            var monthly = ('0' + (data.getMonth() + 1)).slice(-2);
            var day = ('0' + data.getDate()).slice(-2);

            var formatedDate = year + '-' + monthly + '-' + day;
            return formatedDate;
        },
        getNextPaymentFilter() {
            this.loadingTable = true;
            this.loader = true;

            this.actualPage = 0;
            this.totalItems = 0;
            this.payments = [];

            this.$axios.get(`/payments?initial_date=${this.filtersData.initial_date}&finish_date=${this.filtersData.finish_date}&items_per_page=${this.itemsPerPage}&page=${this.actualPage + 1}`)
            .then(res => {
                if (!res.data.data) {
                    return this.notify('Ocorreu um erro ao buscar o financeiro do usuário', res.data)
                };
                const data = res.data.data;
                
                this.actualPage += 1;
                
                this.totalItems = data.data.total;
                
                data.data.next_page_url == null ? this.hasNextPage = false : this.hasNextPage = true;
                
                this.totalSumPayments = data.totalSumPayments;

                if (data.totalSumPayments >= 0) {
                    this.totalCreditValue = data.totalCreditValue;
                    this.totalCreditValueMonthly = data.totalCreditValueMonthly;
                    this.totalCreditValueSemiannual = data.totalCreditValueSemiannual;
                    this.totalCreditValueAnnual = data.totalCreditValueAnnual;

                    this.totalMembershipFee = data.totalMembershipFee;

                    this.totalCharges = data.totalCharges;

                    this.totalFees = data.totalFees;
                    
                    this.totalRefundTransfer = data.totalRefundTransfer || 0;
                    
                    this.totalBonusValue = data.totalBonusDiscount || 0;
                }

                this.financial_situation = data.financial_situation;
                this.financial_situation_description = data.financial_situation_description;
                this.previousDebts = parseFloat(data.previousDebts || 0);

                data.data.data.forEach((item) => {
                    let payments = [];

                    payments.push(item.payment_method);
                    payments.push(`${item.payment_date[8]}${item.payment_date[9]}/${item.payment_date[5]}${item.payment_date[6]}/${item.payment_date[0]}${item.payment_date[1]}${item.payment_date[2]}${item.payment_date[3]}`);
                    payments.push(`R$ ${item.credit_value.replace('.', ',')}`);
                    payments.push(`R$ ${item.membership_fee.replace('.', ',')}`);
                    payments.push(`R$ ${item.fees.replace('.', ',')}`);
                    payments.push(`R$ ${item.charges.replace('.', ',')}`);
                    payments.push(`R$ ${(parseFloat(item.credit_value) + parseFloat(item.membership_fee) + parseFloat(item.charges) + parseFloat(item.fees)).toFixed(2).replace(".", ",")}`);

                    this.payments.push(payments);
                    this.paymentsFullInfos.push(item);
                });

                this.loadingTable = false;
                this.loader = false;
            })
            .catch(err => {
                console.log(err);
                switch (err.response.data.message) {
                    case "Usuário não possui permissões suficientes!":
                        this.$router.push('/inicio');
                        break;
                }
                
                this.notify('Erro ao buscar informações!', 'error');
            })
        },
        getHistoryCSV() {
            this.$axios.get('/all_payments')
            .then(res => {
                // Extrai os dados recebidos
                const payments = res.data.data;

                // Mapeia e traduz os campos para as colunas do XLSX
                const formattedData = payments.map(payment => ({
                    "Método de pagamento": payment.payment_method,
                    "Tipo de pagamento": payment.payment_type,
                    "Data de pagamento": payment.payment_date,
                    "Valor de crédito": payment.credit_value,
                    "Taxa de associação": payment.membership_fee,
                    "Encargos": payment.charges,
                    "Taxas": payment.fees,
                    "Comentários": payment.comments,
                }));

                // Cria a planilha e adiciona os dados
                const worksheet = XLSX.utils.json_to_sheet(formattedData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Pagamentos");

                // Converte o workbook para um blob e faz o download
                const xlsxArrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const blob = new Blob([xlsxArrayBuffer], { type: "application/octet-stream" });
                saveAs(blob, 'Pagamentos.xlsx');
            })
            .catch(err => {
                console.log(err);
            });
        },
        getNextPayment() {
            this.loader = true;
            this.loadingTable = true;

            this.$axios.get(`/payments?initial_date=${this.filtersData.initial_date}&finish_date=${this.filtersData.finish_date}&items_per_page=${this.itemsPerPage}&page=${this.actualPage + 1}`)
            .then(res => {
                if (!res.data.data) {
                    return this.notify('Ocorreu um erro ao buscar o financeiro do usuário', res.data)
                };
                const data = res.data.data;
                
                this.actualPage += 1;
                
                this.totalItems = data.data.total;
                
                data.data.next_page_url == null ? this.hasNextPage = false : this.hasNextPage = true;
                
                this.totalSumPayments = data.totalSumPayments;

                if (data.totalSumPayments >= 0) {
                    this.totalCreditValue = data.totalCreditValue;
                    this.totalCreditValueMonthly = data.totalCreditValueMonthly;
                    this.totalCreditValueSemiannual = data.totalCreditValueSemiannual;
                    this.totalCreditValueAnnual = data.totalCreditValueAnnual;
    
                    this.totalMembershipFee = data.totalMembershipFee;
    
                    this.totalCharges = data.totalCharges;
    
                    this.totalFees = data.totalFees;
                }

                this.financial_situation = data.financial_situation;
                this.financial_situation_description = data.financial_situation_description;

                data.data.data.forEach((item) => {
                    let payments = [];

                    payments.push(item.payment_method);
                    payments.push(`${item.payment_date[8]}${item.payment_date[9]}/${item.payment_date[5]}${item.payment_date[6]}/${item.payment_date[0]}${item.payment_date[1]}${item.payment_date[2]}${item.payment_date[3]}`);
                    payments.push(`R$ ${item.credit_value.replace('.', ',')}`);
                    payments.push(`R$ ${item.membership_fee.replace('.', ',')}`);
                    payments.push(`R$ ${item.fees.replace('.', ',')}`);
                    payments.push(`R$ ${item.charges.replace('.', ',')}`);
                    payments.push(`R$ ${(parseFloat(item.credit_value) + parseFloat(item.membership_fee) + parseFloat(item.charges) + parseFloat(item.fees)).toFixed(2).replace(".", ",")}`);

                    this.payments.push(payments);
                    this.paymentsFullInfos.push(item);
                });

                this.loadingTable = false;
                this.loader = false;
            })
            .catch(err => {
                console.log(err);
                switch (err.response.data.message) {
                    case "Usuário não possui permissões suficientes!":
                        this.$router.push('/inicio');
                        break;
                }
                
                this.notify('Erro ao buscar informações!', 'error');
            })
        },
        exportFinancialSpreadsheet() {
            this.modalFinancialSpreadsheet = true;
            this.loadingInstallments = true;

            this.$axios.get(`/installments/associate/${this.userData.id}`)
            .then(res => {
                this.installments = res.data.data.installments;
                this.loadingInstallments = false;
            })
            .catch(err => {
                this.notify('Erro ao carregar planilha financeira!', 'error');
                this.loadingInstallments = false;
            });
        },
        closeFinancialSpreadsheetModal() {
            this.modalFinancialSpreadsheet = false;
            this.installments = [];
        },
        getMonthName(date) {
            const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 
                          'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
            const d = new Date(date);
            return months[d.getMonth()];
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString('pt-BR');
        },
        formatCurrency(value) {
            return parseFloat(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        getStatusClass(installment) {
            const today = new Date();
            const dueDate = new Date(installment.payment_date);
            
            if (installment.credit_value > 0) {
                return 'status-paid';
            } else if (dueDate < today) {
                return 'status-overdue';
            } else {
                return 'status-pending';
            }
        },
        getStatusText(installment) {
            const today = new Date();
            const dueDate = new Date(installment.payment_date);
            
            if (installment.credit_value > 0) {
                return 'Pago';
            } else if (dueDate < today) {
                return 'Vencido';
            } else {
                return 'Pendente';
            }
        }
    },
    components: { Head, Table, SimpleModal, Button, Input, Select, Loader }
}
</script>

<template>
    <Loader v-if="loader" />

    <section class="bg-see-associates">
        <Head title="Vida Financeira" />

        <section class="filters">
            <Input type="date" label="Desde:" placeholder="10/01/2023" :value="filtersData.initial_date" v-model="filtersData.initial_date" />
            <div class="form-line-space"></div>
            <Input type="date" label="Até:" placeholder="10/01/2023" :value="filtersData.finish_date" v-model="filtersData.finish_date" />
            <div class="form-line-space"></div>
            <Button type="primary" placeholder="Filtrar" class="btn" @buttonPressed="getNextPaymentFilter" />
        </section>

        <p v-if="!loadingTable" id="see-associates-total">Total de pagamentos: <span id="see-associates-total-number">{{ totalItems }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Contribuição: <span id="see-associates-total-number">R$ {{ parseFloat(totalCreditValue).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Contribuição Mensal: <span id="see-associates-total-number">R$ {{ parseFloat(totalCreditValueMonthly).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Contribuição Semestral: <span id="see-associates-total-number">R$ {{ parseFloat(totalCreditValueSemiannual).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Contribuição Anual: <span id="see-associates-total-number">R$ {{ parseFloat(totalCreditValueAnnual).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Taxa de Adesão: <span id="see-associates-total-number">R$ {{ parseFloat(totalMembershipFee).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Honorários: <span id="see-associates-total-number">R$ {{ parseFloat(totalFees).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores pagos por Encargos: <span id="see-associates-total-number">R$ {{ parseFloat(totalCharges).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valores Reembolsados/Transferidos: <span id="see-associates-total-number">R$ {{ parseFloat(totalRefundTransfer).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Valor de Bonificação/Desconto: <span id="see-associates-total-number">R$ {{ parseFloat(totalBonusValue).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total"><strong>VALORES DEVIDOS ANTERIORES:</strong> <span id="see-associates-total-number">R$ {{ parseFloat(previousDebts).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Soma total dos valores pagos: <span id="see-associates-total-number">R$ {{ totalSumPayments.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</span></p>
        <p v-if="!loadingTable" id="see-associates-total">Status da vida financeira: <span :class="financial_situation == 'Adimplente' ? 'green' : financial_situation == 'Inadimplente' ? 'red' : ''">{{ financial_situation == 'Adimplente' ? financial_situation : `Pendência - ${financial_situation_description}` }}</span></p>

        <section class="button">
            <Button type="primary" placeholder="Baixar planilha de pagamentos" @buttonPressed="getHistoryCSV" />
            <Button type="secondary" placeholder="Planilha financeira" @buttonPressed="exportFinancialSpreadsheet" />
        </section>

        <Table v-if="!loadingTable" :hasActions="false" :hasNextPage="hasNextPage" :headers="associateTableCategories" :contents="payments" @loadMore="getNextPayment" />

        <!-- Modal Planilha Financeira -->
        <section v-if="modalFinancialSpreadsheet" class="bg-spreadsheet-modal">
            <div class="spreadsheet-modal-content">
                <div class="spreadsheet-modal-header">
                    <h2>Planilha Financeira - {{ userData.name }}</h2>
                    <svg @click="closeFinancialSpreadsheetModal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="close-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </div>

                <Loader v-if="loadingInstallments" />

                <div v-if="!loadingInstallments && installments.length > 0" class="spreadsheet-body">
                    <div class="spreadsheet-info">
                        <p><strong>Ano:</strong> {{ new Date().getFullYear() }}</p>
                        <p><strong>Total de parcelas:</strong> {{ installments.length }}</p>
                    </div>

                    <div class="installments-grid">
                        <div v-for="(installment, index) in installments" :key="installment.id" class="installment-card">
                            <div class="installment-header">
                                <span class="installment-month">{{ getMonthName(installment.payment_date) }}</span>
                                <span :class="['installment-status', getStatusClass(installment)]">
                                    {{ getStatusText(installment) }}
                                </span>
                            </div>
                            <div class="installment-body">
                                <div class="installment-detail">
                                    <span class="label">Vencimento:</span>
                                    <span class="value">{{ formatDate(installment.payment_date) }}</span>
                                </div>
                                <div v-if="installment.credit_value > 0" class="installment-detail">
                                    <span class="label">Data Pagamento:</span>
                                    <span class="value paid-date">{{ formatDate(installment.paid_at) }}</span>
                                </div>
                                <div class="installment-detail">
                                    <span class="label">Tipo:</span>
                                    <span class="value">{{ installment.payment_type }}</span>
                                </div>
                                <div class="installment-detail">
                                    <span class="label">Valor:</span>
                                    <span class="value-amount">R$ {{ formatCurrency(installment.amount || installment.credit_value) }}</span>
                                </div>
                                <div v-if="installment.comments" class="installment-comments">
                                    <span class="label">Obs:</span>
                                    <span class="value">{{ installment.comments }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!loadingInstallments && installments.length === 0" class="no-installments">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="empty-icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                    </svg>
                    <h3>Nenhuma parcela gerada</h3>
                    <p>Ainda não foram geradas parcelas automáticas para você.</p>
                </div>
            </div>
        </section>
    </section>
</template>

<style scoped>
.bg-add-associate {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 18;
    top: 0;
    left: 0;
    background-color: white;
    overflow-y: auto;
    padding: 0px 30px;
}

.bg-add-associate .close-add-associate {
    position: absolute;
    top: 22px;
    right: 30px;
    cursor: pointer;
    font-size: 18px;
}

.form-add-associate {
    margin-bottom: 150px;
}

.form-add-associate .form-add-associate-line {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 1600px;
    margin: 0px auto;
    margin-bottom: 20px;
}

.form-add-associate .form-add-associate-line .form-add-associate-line-space {
    margin: 0px 10px;
}

.bg-see-associates {
    width: 100%;
    height: auto;
    margin-bottom: 150px;
}

.bg-see-associates #see-associates-total {
    font-size: 18px;
    font-weight: 500;
    color: #2E2E2E;
    margin-bottom: 20px;
}

.bg-see-associates #see-associates-total #see-associates-total-number {
    color: rgb(0, 123, 255);
    font-weight: 600;
}

.form-add-associate-button {
    width: 100%;
}

.button-add-associate {
    width: 300px;
    max-width: 100%;
    margin-bottom: 20px;
}

.associate-infos-simple-modal {
    width: 100%;
}

.associate-infos-simple-modal p {
    font-size: 16px;
    font-weight: 500;
    margin: 5px 0px;
}

.associate-infos-simple-modal span {
    font-weight: 400;
}

.blue {
    color: rgb(12, 121, 198);
    font-weight: 600 !important;
}

.orange {
    color: rgb(230, 149, 0);
    font-weight: 600 !important;
}

.green {
    color: rgb(17, 162, 1);
    font-weight: 600 !important;
}

.red {
    color: rgb(162, 1, 1);
    font-weight: 600 !important;
}

.filters {
    max-width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
}

.filters .btn {
    margin-top: 25px;
}

.button {
    width: 300px;
    margin-top: 50px;
    margin-bottom: 20px;
}

@media screen and (max-width:800px) {
    .form-add-associate .form-add-associate-line {
        flex-direction: column;
    }

    .form-add-associate .form-add-associate-line-space {
        margin: 10px 0px !important;
    }

    .filters {
        flex-direction: column;
        width: 100%;
        max-width: 100%;
    }

    .filters .btn {
        margin-top: 10px;
    }
}

.bg-spreadsheet-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.spreadsheet-modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 1200px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 30px;
}

.spreadsheet-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    border-bottom: 2px solid #e0e0e0;
    padding-bottom: 15px;
}

.spreadsheet-modal-header h2 {
    color: #2c3e50;
    font-size: 24px;
    font-weight: 600;
}

.close-icon {
    width: 30px;
    height: 30px;
    cursor: pointer;
    color: #e74c3c;
    transition: transform 0.2s;
}

.close-icon:hover {
    transform: scale(1.1);
}

.spreadsheet-info {
    display: flex;
    gap: 30px;
    margin-bottom: 25px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
}

.spreadsheet-info p {
    font-size: 16px;
    color: #2c3e50;
}

.installments-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
}

.installment-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.3s;
}

.installment-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.installment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.installment-month {
    color: white;
    font-weight: 600;
    font-size: 16px;
}

.installment-status {
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
}

.status-paid {
    background: #27ae60;
    color: white;
}

.status-pending {
    background: #f39c12;
    color: white;
}

.status-overdue {
    background: #e74c3c;
    color: white;
}

.installment-body {
    padding: 15px;
}

.installment-detail {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
}

.installment-detail .label {
    color: #7f8c8d;
    font-weight: 500;
}

.installment-detail .value {
    color: #2c3e50;
    font-weight: 600;
}

.installment-detail .paid-date {
    color: #27ae60;
}

.installment-detail .value-amount {
    color: #3498db;
    font-weight: 700;
    font-size: 16px;
}

.installment-comments {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #ecf0f1;
    font-size: 13px;
}

.installment-comments .label {
    color: #7f8c8d;
    font-weight: 600;
    display: block;
    margin-bottom: 5px;
}

.installment-comments .value {
    color: #34495e;
    line-height: 1.5;
}

.no-installments {
    text-align: center;
    padding: 60px 20px;
}

.empty-icon {
    width: 80px;
    height: 80px;
    color: #bdc3c7;
    margin: 0 auto 20px;
}

.no-installments h3 {
    color: #2c3e50;
    font-size: 20px;
    margin-bottom: 10px;
}

.no-installments p {
    color: #7f8c8d;
    font-size: 16px;
}
</style>